import { useState } from 'react';

import { type SingleFlight, createSingleFlight } from './singleFlight';

/**
 * Serializes asynchronous actions initiated by one UI flow.
 */
export const useSingleFlight = (): SingleFlight => {
  const [singleFlight] = useState(createSingleFlight);
  return singleFlight;
};
